import React, { useState, useEffect } from 'react';
import { ConnectWebSocketForOverlay, SetSocketMessageHandler, ClearSocketMessageHandler, DisconnectWebSocket } from '../../utilities/BL/Zones';
import { GetSettings } from '../../utilities/BL/RubaQuiz';
import { QRCodeSVG } from 'qrcode.react';

export function RubaQuiz() {
    const [offsetY, setOffsetY] = useState(0);
    const [bannerMode, setBannerMode] = useState('invitation'); // invitation, winner
    const [winnerName, setWinnerName] = useState('');
    const [connectionStatus, setConnectionStatus] = useState('idle');

    // Visibility flowState (idle, entering, visible, fadingOut)
    const [flowState, setFlowState] = useState('idle');
    const [showConfetti, setShowConfetti] = useState(false);

    // 1. Force Transparent Background for OBS Overlay
    useEffect(() => {
        const originalBodyBg = document.body.style.backgroundColor;
        const originalHtmlBg = document.documentElement.style.backgroundColor;
        const rootElement = document.getElementById('root');

        document.body.style.backgroundColor = 'transparent';
        document.documentElement.style.backgroundColor = 'transparent';
        if (rootElement) {
            rootElement.style.backgroundColor = 'transparent';
        }

        return () => {
            document.body.style.backgroundColor = originalBodyBg;
            document.documentElement.style.backgroundColor = originalHtmlBg;
            if (rootElement) {
                rootElement.style.removeProperty('background-color');
            }
        };
    }, []);

    // 2. Control transitions (entering -> visible, fadingOut -> idle)
    useEffect(() => {
        let timeout;
        if (flowState === 'entering') {
            timeout = setTimeout(() => setFlowState('visible'), 500);
        } else if (flowState === 'fadingOut') {
            timeout = setTimeout(() => {
                setFlowState('idle');
                setShowConfetti(false);
            }, 500);
        }
        return () => clearTimeout(timeout);
    }, [flowState]);

    const handleOverlayVisibilityChange = (visible) => {
        if (visible) {
            setFlowState((prev) => {
                if (prev === 'idle' || prev === 'fadingOut') {
                    return 'entering';
                }
                return prev;
            });
        } else {
            setFlowState((prev) => {
                if (prev !== 'idle' && prev !== 'fadingOut') {
                    return 'fadingOut';
                }
                return prev;
            });
        }
    };

    // 3. Load Initial Settings and Connect WebSocket
    useEffect(() => {
        const init = async () => {
            // Load current settings from API (prevents starting blank on overlay page reload)
            const res = await GetSettings();
            if (res.success && res.data) {
                setOffsetY(res.data.offsetY);
                setBannerMode(res.data.bannerMode);
                setWinnerName(res.data.winnerName);
                
                // Initialize visibility state
                if (res.data.isOverlayVisible) {
                    setFlowState('visible');
                    if (res.data.bannerMode === 'winner') {
                        setShowConfetti(true);
                    }
                } else {
                    setFlowState('idle');
                }
            }

            // Connect overlay socket
            await ConnectWebSocketForOverlay(
                'rubaquiz',
                (status) => setConnectionStatus(status),
                (msg) => console.log('[RubaQuizOverlay] WS Toast:', msg)
            );

            SetSocketMessageHandler(handleIncomingMessage);
        };

        const handleIncomingMessage = (message) => {
            if (!message || !message.type) return;

            const type = message.type.toLowerCase();
            const data = message.data || message;

            if (type === 'config') {
                if (data.offsetY !== undefined) {
                    setOffsetY(data.offsetY);
                }
            } else if (type === 'state') {
                if (data.bannerMode) {
                    setBannerMode(data.bannerMode);
                    if (data.bannerMode === 'winner' && data.isOverlayVisible) {
                        setShowConfetti(true);
                    } else {
                        setShowConfetti(false);
                    }
                }
                if (data.winnerName !== undefined) {
                    setWinnerName(data.winnerName);
                }
                if (data.isOverlayVisible !== undefined) {
                    handleOverlayVisibilityChange(data.isOverlayVisible);
                }
            }
        };

        init();

        return () => {
            ClearSocketMessageHandler();
            DisconnectWebSocket();
        };
    }, []);

    if (flowState === 'idle') return null;

    return (
        <div className="rubaquiz" style={{ bottom: `${offsetY}px` }}>
            {/* GPU-Accelerated CSS Confetti */}
            {showConfetti && bannerMode === 'winner' && (
                <div className="ruba-confetti">
                    {[...Array(40)].map((_, i) => (
                        <div key={i} className="ruba-confetti__piece" />
                    ))}
                </div>
            )}

            {/* Bottom Floating Banner Overlay */}
            {/* <div className={`rubaquiz__banner rubaquiz__banner--${flowState} shadow`}>
                {bannerMode === 'invitation' ? (
                    <>
                        {/* Left Side QR /}
                        <div className="rubaquiz__logo rubaquiz__logo--left" style={{ padding: '6px', backgroundColor: '#d9d9d9', borderRadius: '12px' }}>
                            <div className="text-center">
                                <p className="mb-0 fw-bold text-dark mb-1" style={{ fontSize: '0.9rem', lineHeight: '1.0' }}>Participa aquí</p>
                            </div>
                            <QRCodeSVG 
                                value={`${window.location.origin}/rubaquiz?utm_source=rubaquiz_web&utm_medium=overlay_screen&utm_campaign=fdm_xolos_s2`} 
                                size={145}
                                bgColor={"#d9d9d9"} 
                                fgColor={"#000000"} 
                                level={"H"} 
                                imageSettings={{
                                    src: "/img/page/interaktia-transparent.png",
                                    x: undefined,
                                    y: undefined,
                                    height: 60,
                                    width: 60,
                                    excavate: true, 
                                }}
                            />
                        </div>

                        {/* Center Banner text & Ruba Brand /}
                        <div className="rubaquiz__content">
                            <div className="d-flex flex-column align-items-center justify-content-center">
                                <p className="rubaquiz__title mb-0">Participa en la Trivia <img src='/img/overlays/rubaquiz/ruba-logotipo.png' style={{ width: '280px' }} /></p>
                                <p className="rubaquiz__credits">Powered by Interaktia</p>
                            </div>
                        </div>

                        {/* Right Side QR /}
                        <div className="rubaquiz__logo rubaquiz__logo--right" style={{ padding: '6px', backgroundColor: '#d9d9d9', borderRadius: '12px' }}>
                            <div className="text-center">
                                <p className="mb-0 fw-bold text-dark mb-1" style={{ fontSize: '0.9rem', lineHeight: '1.0' }}>Participa aquí</p>
                            </div>
                            <QRCodeSVG 
                                value={`${window.location.origin}/rubaquiz?utm_source=rubaquiz_web&utm_medium=overlay_screen&utm_campaign=fdm_xolos_s2`} 
                                size={145}
                                bgColor={"#d9d9d9"} 
                                fgColor={"#000000"} 
                                level={"H"} 
                                imageSettings={{
                                    src: "/img/page/interaktia-transparent.png",
                                    x: undefined,
                                    y: undefined,
                                    height: 60,
                                    width: 60,
                                    excavate: true, 
                                }}
                            />
                        </div>
                    </>
                ) : (
                    <>
                        {/* Left Side QR /}
                        <div className="rubaquiz__logo rubaquiz__logo--left">
                            <img src="/img/overlays/rubaquiz/ruba-logotipo.png" alt="QR Code Left" style={{ width: '180px', height: '75px' }} />
                        </div>

                        {/* Center Banner text & Ruba Brand /}
                        <div className="rubaquiz__content">
                            <p className="rubaquiz__subtitle animate-pulse text-warning mb-1">
                                🎉 ¡Tenemos un ganador! 🎉
                            </p>
                            <h2 className="rubaquiz__title text-uppercase">
                                {winnerName || 'Y el ganador es...'}
                            </h2>
                            <p className="rubaquiz__credits">Powered by Interaktia</p>
                        </div>

                        {/* Right Side QR /}
                        <div className="rubaquiz__logo rubaquiz__logo--right">
                            <img src="/img/overlays/rubaquiz/ruba-logotipo.png" alt="QR Code Right" style={{ width: '180px', height: '75px' }} />
                        </div>
                    </>
                )}
            </div> */}

            <div className={`rubaquiz__banner rubaquiz__banner--${flowState}`}> {/* shadow */}
                {bannerMode === 'invitation' ? (
                    <div className='rubaquiz__banner--v2'>
                        <img src='/img/overlays/rubaquiz/cintillo-ruba-1536-x-180-px.png' className='rubaquiz__banner--v2__Image--Md' />
                        <img src='/img/overlays/rubaquiz/cintillo-ruba-1920-x-180-px.png' className='rubaquiz__banner--v2__Image--Lg' />
                        <div className='rubaquiz__banner--v2__QR-Overlay'>
                            <QRCodeSVG 
                                value={`${window.location.origin}/rubaquiz?s=obs`} 
                                size={256}
                                style={{ width: '82%', height: '82%', display: 'block' }}
                                bgColor={"#d9d9d9"} 
                                fgColor={"#000000"} 
                                level={"H"} 
                                imageSettings={{
                                    src: "/img/page/interaktia-transparent.png",
                                    x: undefined,
                                    y: undefined,
                                    height: 50,
                                    width: 50,
                                    excavate: true, 
                                }}
                            />
                        </div>
                    </div>
                ) : (
                    <div className='rubaquiz__banner__winner'>
                        {/* Left Side QR */}
                        <div className="rubaquiz__logo rubaquiz__logo--left">
                            {/* <img src="/img/overlays/rubaquiz/ruba-logotipo-negro.png" alt="QR Code Left" style={{ width: '180px', height: '75px' }} /> */}
                            <img src="/img/overlays/rubaquiz/ruba-logotipo-negro.png" alt="QR Code Left" style={{ width: '180px', height: '75px' }} />
                        </div>

                        {/* Center Banner text & Ruba Brand */}
                        <div className="rubaquiz__content">
                            <p className="rubaquiz__subtitle animate-pulse mb-1">
                                🎉 ¡Tenemos ganador(a) de la Trivia Ruba ! 🎉
                            </p>
                            <h2 className="rubaquiz__title text-uppercase">
                                {winnerName || 'Y el ganador es...'}
                            </h2>
                            <p className="rubaquiz__credits">Powered by Interaktia</p>
                        </div>

                        {/* Right Side QR */}
                        <div className="rubaquiz__logo rubaquiz__logo--right">
                            {/* <img src="/img/overlays/rubaquiz/ruba-cel-y-franja.png" alt="QR Code Right" style={{ width: '381px', height: '180px' }} /> */}
                            <img src="/img/overlays/rubaquiz/ruba-cel-y-franja.png" alt="QR Code Right" style={{ width: '381px', height: '180px' }} />
                        </div>
                    </div>
                )}
            </div>

            {/* Tiny Indicator for OBS Connection Status */}
            {connectionStatus === 'error' && (
                <div style={{ position: 'fixed', bottom: 5, right: 5, background: 'red', color: 'white', padding: '3px 8px', fontSize: '9px', borderRadius: '4px', opacity: 0.8 }}>
                    D {/* SignalR Error */}
                </div>
            )}
        </div>
    );
}
export default RubaQuiz;
